var _rect, _path, _path2, _g, _rect2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEgp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2441_3742",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 23,
    height: 23
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 23,
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2441_3742)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0V23H23V0H0Z",
    fill: "#F7FCFF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_2441_3742",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 23,
    height: 23
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0V23H23V0H0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_2441_3742)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0V7.66667H23V0H0Z",
    fill: "#BF2714"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 15.3335V23.0002H23V15.3335H0Z",
    fill: "#272727"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.81206 9.79443L9.53006 9.83832L9.34983 15.0802L8.63184 15.0363L8.81206 9.79443Z",
    fill: "#C09302"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.56231 10.1196L10.2799 10.1737L10.0997 14.4242L9.38208 14.3701L9.56231 10.1196Z",
    fill: "#C09302"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3129 10.438L11.0293 10.5164L10.849 13.445L10.1327 13.3667L10.3129 10.438Z",
    fill: "#C09302"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1878 9.79443L13.4698 9.83832L13.65 15.0802L14.368 15.0363L14.1878 9.79443Z",
    fill: "#C09302"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4376 10.1196L12.72 10.1737L12.9002 14.4242L13.6178 14.3701L13.4376 10.1196Z",
    fill: "#C09302"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.687 10.438L11.9706 10.5164L12.1508 13.445L12.8672 13.3667L12.687 10.438Z",
    fill: "#C09302"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4807 14.6882L10.7802 14.4742L11.0767 12.7485L11.7773 12.9626L11.4807 14.6882Z",
    fill: "#C09302"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0171 14.6882L12.7177 14.4742L12.4211 12.7485L11.7205 12.9626L12.0171 14.6882Z",
    fill: "#C09302"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8392 14.6723H11.1205V12.978H11.8392V14.6723Z",
    fill: "#C09302"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5187 10.4585L11.2372 10.482L11.1952 12.7637L10.4767 12.7402L10.5187 10.4585Z",
    fill: "#C09302"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7687 10.4585L12.4872 10.482L12.4452 12.7637L11.7267 12.7402L11.7687 10.4585Z",
    fill: "#C09302"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.58667 15.2594L9.77333 14.334C10.536 14.6074 11.1215 14.7427 11.5208 14.7427C11.9201 14.7427 12.5057 14.6074 13.2683 14.334L13.455 15.2594C12.6368 15.5528 11.9951 15.701 11.5208 15.701C11.0465 15.701 10.4049 15.5528 9.58667 15.2594Z",
    fill: "#C09302"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.82785 9.79673C8.77993 9.16365 9.05783 8.73511 9.5288 8.78977C9.68366 8.80774 9.85759 8.86882 10.0893 8.97362C10.1569 9.00458 10.1569 9.00458 10.2227 9.03563C10.5412 9.18666 10.6277 9.22548 10.6456 9.23059C10.5751 9.20928 10.7829 8.70829 10.8306 8.62385C10.8362 8.67747 10.8123 8.66984 10.7548 8.65451L10.1065 8.48151L10.568 7.8502C10.7293 7.62954 10.9442 7.52011 11.1893 7.52011C11.2147 7.52011 11.2384 7.51853 11.3163 7.51214C11.3739 7.50748 11.3739 7.50748 11.4387 7.5039C11.8872 7.48453 12.2088 7.65362 12.2088 8.26853C12.2088 8.48853 12.2296 8.84229 12.264 9.11068C12.2756 9.20096 12.2979 9.28546 12.232 9.32258C12.2347 9.29055 12.3918 9.2079 12.6361 9.0717L12.6654 9.05536C13.3751 8.66039 13.458 8.62374 13.6868 8.80912C13.8393 8.93266 13.9844 9.15488 14.1471 9.48618L13.5457 10.0111C13.4408 9.79737 13.3573 9.6677 13.3175 9.63149C13.4079 9.71525 13.1034 9.85008 12.9423 9.93974L12.9134 9.95582C12.3608 10.2639 12.288 10.3007 12.13 10.3007C11.7 10.3007 11.5456 9.71348 11.5034 8.87249C11.3707 9.45475 10.9749 10.1895 10.6488 10.1895C10.506 10.1895 10.5747 10.2197 9.98187 9.93855C9.91976 9.90924 9.91976 9.90924 9.85834 9.88114C9.67875 9.7999 9.54919 9.75433 9.46745 9.7446C9.47083 9.73947 9.48287 9.7222 9.49637 9.70678L8.82785 9.79673Z",
    fill: "#C09302"
  })))), /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 23,
    rx: 11.5,
    fill: "url(#paint0_linear_2441_3742)",
    style: {
      mixBlendMode: "overlay"
    }
  }), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 22,
    height: 22,
    rx: 11,
    stroke: "black",
    strokeOpacity: 0.1
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2441_3742",
    x1: 11.5,
    y1: 0,
    x2: 11.5,
    y2: 23,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.3
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEgp);
export default __webpack_public_path__ + "static/media/EGP.3cc6d2bcfbb84c95a9c5e94135eb35bf.svg";
export { ForwardRef as ReactComponent };